import '../../sass/global.scss'
// import dama from "/modules/dama.js";
// import apiDrupal from "./api.js";
// const dm = new dama();
import "../config/interfaces";
import Modal from "../components/modal";
// @ts-ignore
import * as Bouncer from "formbouncerjs"
import Loader from '../components/LoaderNew'
// const api = new apiDrupal();
declare global {
    interface Window {
        dama: any;
        datalayer: any;
        SHA256: any;
        drupalSettings: any;
        initSession: any;
    }
}

window.addEventListener('DOMContentLoaded', () => {
    /* ON LOAD */
    validateNewsletter()
    playVideo();
    scrollGame();
    datalayersGenerals()
})

window.addEventListener('scroll', () => {
    const scrollTop = window.scrollY

    if (scrollTop == 0) {
        //@ts-ignore
        document.querySelector('#block-aguila-content')?.style.paddingTop = '0px'
    }
    
    else {
        if (window.innerWidth <= 1199) {
            //@ts-ignore
            document.querySelector('#block-aguila-content')?.style.paddingTop = '58px'
        }

        else {
            //@ts-ignore
            document.querySelector('#block-aguila-content')?.style.paddingTop = '88px'
        }
    }
})

window.addEventListener("load", () => {
    new Modal('#newsletterModal', { activator: '#newsletterImage' })
    new Modal('#welcomeModal')
    new Modal('#registerPointsModal')
    new Loader()
})

const datalayersGenerals = () => {
    const logo = document.querySelector('#header .menu__header--logo')
    const buttonYes = document.querySelector('#agv2 .age_gate_yes')
    const rememberData = document.querySelector('#agv2 input[name="checkbox"]') as any
    const itemsHeader = document.querySelectorAll('#block-aguila-abpacoheader .item-link a')
    const itemsFooter = document.querySelectorAll('#block-menufooter .menu-icon a')
    const itemsFooterLegals = document.querySelectorAll('#block-tagsfooter .field--name-field-link-footer a')
    const socialMedia = document.querySelectorAll('#block-socialmedia .field--name-body .social-networks a')
    const abiLegal = document.querySelector('#block-footerbotton .field--name-field-text-copy a') as HTMLElement

    logo?.addEventListener('click', () => {
        window.dataLayer.push({
            'event': 'GAEvent',
            'event_category': 'Content',
            'event_action': 'Button',
            'event_label': 'Inicio',
            'interaction':'true',
            'component_name': 'Header',
            'element_text': 'Inicio',
        });  
    })

    buttonYes?.addEventListener('click', () => {
        if (rememberData.checked) {
            window.dataLayer.push({
                'event': 'GAEvent',
                'event_category': 'Age Gate',
                'event_action': 'Interaction',
                'event_label': 'Success',
                'interaction':'false',
                'component_name': 'Age_Gate',
                'element_text': 'SI',
            });
        }
    })

    itemsHeader.forEach((item: HTMLElement) => {
        item.addEventListener('click', () => {
            window.dataLayer.push({
                'event': 'GAEvent',
                'event_category': 'Content',
                'event_action': 'Button',
                'event_label': `${item.innerText}`,
                'interaction':'true',
                'component_name': 'Header',
                'element_text': `${item.innerText}`,
            });
        })
    });

    itemsFooter.forEach((item: HTMLElement) => {
        item.addEventListener('click', () => {
            window.dataLayer.push({
                'event': 'GAEvent',
                'event_category': 'Content Footer Menu',
                'event_action': 'Button',
                'event_label': `${item.innerText}`,
                'interaction':'true',
                'component_name': 'Footer',
                'element_text': `${item.innerText}`,
            });
        })
    });

    itemsFooterLegals.forEach((item: HTMLElement) => {
        item.addEventListener('click', () => {
            window.dataLayer.push({
                'event': 'GAEvent',
                'event_category': 'Content Legal',
                'event_action': 'Button',
                'event_label': `${item.innerText}`,
                'interaction':'true',
                'component_name': 'Content_Legal',
                'element_text': `${item.innerText}`,
            });
        })
    });

    socialMedia.forEach((item: HTMLElement) => {
        item.addEventListener('click', () => {
            let img = item.querySelector('img')
            window.dataLayer.push({
                'event': 'GAEvent',
                'event_category': 'Content Legal',
                'event_action': 'Button',
                'event_label': `${img.getAttribute('alt')}`,
                'interaction':'true',
                'component_name': 'Content_Legal',
                'element_text': `${img.getAttribute('alt')}`,
            });
        })
    });

    abiLegal?.addEventListener('click', () => {
        window.dataLayer.push({
            'event': 'GAEvent',
            'event_category': 'Content Legal',
            'event_action': 'Button',
            'event_label': `${abiLegal.innerText}`,
            'interaction':'true',
            'component_name': 'Content_Legal',
            'element_text': `${abiLegal.innerText}`,
        });
    })
}

const validateNewsletter = () => {
    window.addEventListener('load', () => {
        let isActive = { email: false, terms: false }
        let inputEmail: HTMLInputElement = document.querySelector('.co-aguila-100-years-newsletter-form .form-email')
        let inputTerms: HTMLInputElement = document.querySelector('.co-aguila-100-years-newsletter-form .form-checkbox')
        let inputSubmit = document.querySelector('.co-aguila-100-years-newsletter-form .form-submit')

        const enableButton = (enable: boolean) => {
            enable ? inputSubmit.classList.add('active-button') : inputSubmit.classList.remove('active-button')
        }

        if (inputEmail) {
            inputEmail.oninput = function (e: any) {
                isActive.email =
                    e.target.value.match(/^[a-zA-Z0-9!#$%&'*/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/) ?
                        true : false
                enableButton(isActive.terms && isActive.email)

                let errorMessage: HTMLElement = document.querySelector('.co-aguila-100-years-newsletter-form .error-input')
                errorMessage && errorMessage.remove()
            }
        }

        if (inputTerms) {
            inputTerms.onchange = function (e: any) {
                isActive.terms = e.target.checked
                enableButton(isActive.terms && isActive.email)
            }
        }

        let refForm = document.querySelector('#newsletter form')
        refForm && refForm.addEventListener('keypress', (e: any) => {
            if (e.keyCode == 13) e.preventDefault();
        })
    })

    // @ts-ignore
    new Bouncer('#newsletter form', {
        patterns: {
            email: /^[a-zA-Z0-9!#$%&'*/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/,
        },
        messages: {
            missingValue: {
                email: "Ingresa tu correo electrónico",
                default: "Campo obligatorio",
            },
            patternMismatch: {
                email: "Ingresa un correo electrónico válido",
            }
        },
    });
}


const playVideo = () => {

    window.onload = function () {

        // Show video content
        containerQuestions();
        let containerCanvasVideo = document.querySelector('.container-canvas--video') as any;
        if (containerCanvasVideo) {
            containerCanvasVideo.style.visibility = 'visible';
            containerCanvasVideo.style.opacity = 1;

            let containerCanvas = document.querySelector('canvas') as any;
            containerCanvas.remove();
            containerCanvas.style.width = 0;
            containerCanvas.style.height = 0;

            // Start video with click event
            let video = document.getElementById('videoGame') as any;
            let audio = document.getElementById('playAudioVideo') as any;

            let soundIcon = document.querySelector('.btn-audio img') as any;
            if (soundIcon) {
                soundIcon.addEventListener('click', () => {
                    if (!soundIcon.classList.contains('activeSound')) {
                        soundIcon.src = `${window.location.protocol + `//` + window.location.host}/themes/custom/aguila/sources/dist/img/oasis_barranquilla/video/nosound.svg`
                        soundIcon.classList.add('activeSound')
                        //audio.play();
                        audio.muted = false;
                    } else {
                        soundIcon.src = `${window.location.protocol + `//` + window.location.host}/themes/custom/aguila/sources/dist/img/oasis_barranquilla/video/sound.svg`
                        soundIcon.classList.remove('activeSound')
                        //audio.pause();
                        audio.muted = true;
                    }
                });
            }

            // Fix video for Firefox
            if (navigator.userAgent.indexOf("Firefox") != -1 || navigator.userAgent.indexOf("Safari") != -1) {

                if (window.innerWidth > 576) {
                    let containerVideo = document.querySelector('.c2canvasdiv__video') as any;
                    let widthContainer = containerVideo.clientWidth + 20;
                    video.style.minHeight = widthContainer + 'px';
                    video.style.border = '11px solid rgba(0, 0, 0, 0.21)';
                    video.style.borderRadius = '5px';
                    containerVideo.style.backgroundColor = 'rgba(0, 0, 0, 0)';
                    containerVideo.style.display = 'flex';
                    containerVideo.style.flexFlow = 'column';
                    containerVideo.style.padding = '0px';
                }
            }
        }

    }
}

const containerQuestions = () => {
    let containerCanvasVideo = document.querySelector('.container-canvas--questions') as any;
    if (containerCanvasVideo) {
        containerCanvasVideo.style.visibility = 'visible';
        containerCanvasVideo.style.opacity = 1;
    }
}

const scrollGame = () => {
    let container = document.querySelector('.container-game-barranquilla') as any;
    if (container) {
        if (screen.width < 767) {
            window.scrollTo(0, 100);
        }
    }
}